'use strict';

(function () {
	if (!customElements.get('multi-scroll-gallery')) {

		const centerStickyWrapper = (height, stickyWrapper, isMobile) => {
			if (isMobile) {
				const topOffset = 30;
				stickyWrapper.style.top = `${topOffset}px`;
				return topOffset;
			}

			const availableHeight = Math.max(window.innerHeight - height, 0);
			const topOffset = Math.max(availableHeight / 2, 0);
			stickyWrapper.style.top = `${topOffset}px`;
			return topOffset;
		};

		const getAllItemsVisibleHeight = (contentWrapper, contentItems) => {
			const previousMaxHeight = contentWrapper.style.maxHeight;
			const itemClasses = [];

			contentWrapper.style.maxHeight = 'none';

			contentItems.forEach((item) => {
				itemClasses.push({
					active: item.classList.contains('active'),
					prevItem: item.classList.contains('prev-item'),
					prevPrevItem: item.classList.contains('prev-prev-item')
				});
				item.classList.add('active');
				item.classList.remove('prev-item');
				item.classList.remove('prev-prev-item');
			});

			const fullHeight = contentWrapper.scrollHeight;

			contentItems.forEach((item, index) => {
				item.classList.toggle('active', itemClasses[index].active);
				item.classList.toggle('prev-item', itemClasses[index].prevItem);
				item.classList.toggle('prev-prev-item', itemClasses[index].prevPrevItem);
			});

			contentWrapper.style.maxHeight = previousMaxHeight;

			return fullHeight;
		};
		class MultiScrollGalllery extends HTMLElement {
			constructor() {
				super();
				this.activeItem = 0;
				this.horizontalSection = this.querySelector('.multi-scroll-gallery__horizontal-section');
				this.stickyWrapper = this.querySelector('.multi-scroll-gallery__sticky-wrapper');
				this.imgWrapper = this.querySelector('.multi-scroll-gallery__right');
				this.imgWrapperOuter = this.querySelector('.multi-scroll-gallery__right-wrapper');
				this.contentWrapper = this.querySelector('.multi-scroll-gallery__left');
				this.contentItems = this.querySelectorAll('.multi-scroll-gallery__item');
				this.images = this.querySelectorAll('.multi-scroll-gallery__right .multi-scroll-gallery__image-wrapper');
				this.mediaItems = this.querySelectorAll('.multi-scroll-gallery .media');
				this.paginationDots = this.querySelectorAll('.multi-scroll-gallery__pagination-dot');
				this.optimizedScrollHandler = null;
			}

			connectedCallback() {
				if (this.contentItems.length < 2) {
					return
				}

				this.initScroll();

				window.addEventListener('resize', () => {
					this.initScroll.call(this);
				});
			}
		}
	

		MultiScrollGalllery.prototype.initScroll = function() {
			const isMobile = window.innerWidth < 750;
			const mobileViewportHeight = Math.max(window.innerHeight - 80, 0);
			const mobileReservedSpace = 90;
			const fullContentHeight = getAllItemsVisibleHeight(this.contentWrapper, this.contentItems);
			let imageHeight = window.innerWidth >= 1025
				? this.images[0].offsetHeight 
				: Math.round(window.innerHeight * 0.55);
			if (isMobile) {
				const availableImageHeight = window.innerHeight - fullContentHeight - mobileReservedSpace;
				imageHeight = Math.max(availableImageHeight, 0);
			}

			const mediaHeight = window.innerWidth >= 1025 ? '' : `${imageHeight}px`;
			const postItemsScrollBuffer = isMobile ? fullContentHeight : 0;

			this.mediaItems.forEach((mediaItem) => {
				mediaItem.style.height = mediaHeight;
			});

			const topOffset = centerStickyWrapper(imageHeight, this.stickyWrapper, isMobile);
			const scrollDistance = imageHeight * this.images.length;
			this.horizontalSection.style.height = `${scrollDistance + topOffset + postItemsScrollBuffer}px`;
			this.imgWrapper.style.maxHeight = `${imageHeight}px`;
			if (isMobile) {
				this.imgWrapperOuter.style.maxHeight = `${imageHeight}px`;
				this.contentWrapper.style.maxHeight = `${mobileViewportHeight}px`;
				this.stickyWrapper.style.maxHeight = `${mobileViewportHeight}px`;
			} else {
				this.imgWrapperOuter.style.maxHeight = '';
				this.contentWrapper.style.maxHeight = `${imageHeight}px`;
				this.stickyWrapper.style.maxHeight = `${imageHeight}px`;
			}
			
			const onScroll = () => {
				const scrollTop = window.pageYOffset;
				const distFromTop = this.horizontalSection.getBoundingClientRect().top + window.pageYOffset;
				const scrollPosition = Math.max(0, Math.min(scrollTop - distFromTop, scrollDistance - imageHeight));
				this.imgWrapper.style.transform = `translateY(-${scrollPosition}px)`;

				// add active class to current item
				this.images.forEach((image, index) => {
					if (image.offsetTop <= scrollPosition && scrollPosition < (image.offsetTop + imageHeight)) {
						this.activeItem = index;

						this.contentItems.forEach((item, contentIndex) => {
							item.classList.remove('active');
							item.classList.remove('prev-item');
							item.classList.remove('prev-prev-item');
							if (contentIndex === this.activeItem) {
								item.classList.add('active');
							}
							if (contentIndex === this.activeItem - 1) {
								item.classList.add('prev-item');
							}
							if (contentIndex === this.activeItem - 2) {
								item.classList.add('prev-prev-item');
							}
						});

						this.paginationDots.forEach((dot, dotIndex) => {
							dot.classList.toggle('active', dotIndex === this.activeItem);
						});
					}
				});
			};

			const optimizedScroll = () => {
				requestAnimationFrame(onScroll);
			};

			if (this.optimizedScrollHandler) {
				window.removeEventListener('scroll', this.optimizedScrollHandler);
			}

			this.optimizedScrollHandler = optimizedScroll;
			window.addEventListener('scroll', this.optimizedScrollHandler);
			optimizedScroll();
		};

		customElements.define('multi-scroll-gallery', MultiScrollGalllery);
	}
	
})();